import { render, staticRenderFns } from "./GoodsOfferStatusCell.vue?vue&type=template&id=69fa5a66"
import script from "./GoodsOfferStatusCell.vue?vue&type=script&lang=js"
export * from "./GoodsOfferStatusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports